var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.qualityHistogram || _vm.difficultyHistogram
    ? _c("div", { staticClass: "row omegaup-feedback-row" }, [
        _c("h5", { staticClass: "omegaup-feedback-title w-100" }, [
          _vm._v(_vm._s(_vm.T.wordsUsersFeedback))
        ]),
        _vm.qualityHistogram
          ? _c(
              "div",
              { class: _vm.containerClass },
              [
                _c("omegaup-problem-histogram", {
                  attrs: {
                    histogram: _vm.qualityHistogram,
                    score: _vm.qualityScore,
                    type: _vm.HistogramType.Quality
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.difficultyHistogram
          ? _c(
              "div",
              { class: _vm.containerClass },
              [
                _c("omegaup-problem-histogram", {
                  attrs: {
                    histogram: _vm.difficultyHistogram,
                    score: _vm.difficultyScore,
                    type: _vm.HistogramType.Difficulty
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }